import { useState, useEffect } from 'react'
import _ from 'lodash'
import { Anchor } from 'antd'
import { connect } from 'react-redux'
import confUtil from '../../../../lib/confUtil'
import SideBar from '../../Common/HorizontalLayout/SideBar'
import { ANCHOR, ANCHOR_LINK_MAP } from '../constants'
import { DASHBOARD_REMINDER_ANCHOR } from './DashboardReminder'
import styles from './Sidebar.css'

const { Link } = Anchor

const ANCHOR_GA_LABEL_MAP = {
  [ANCHOR.SALE_STAT]: 's_ancor_saleoverview',
  [ANCHOR.BESTSELLER_RANKING]: 's_ancor_topselling',
  [ANCHOR.PAGE_VIEWS_ANALYSIS]: 's_pv'
}

const getSideBarItems = (envConf) => {
  return [
    ..._.map(ANCHOR_LINK_MAP, anchor => {
      const { link, linkTitle, subItems } = anchor
      return {
        label: (
          <Link
            href={`#${link}`}
            title={linkTitle}
            subItems={subItems}
          />
        )
      }
    }),
    {
      label: (
        <Link
          href={`#${DASHBOARD_REMINDER_ANCHOR}`}
          title='儀表板小提醒'
        />
      )
    },
    {
      label: (
        <Link
          href={confUtil.getAbsUrl(envConf)('sellerAdmin')}
          title='回店家後台'
        />
      )
    }
  ]
}

const Sidebar = (props) => {
  const { onGaClick, envConf } = props
  const [defaultSelected, setDefaultSelected] = useState(null)
  const { hash } = _.get(global.window, 'location', {})

  const onSelect = selectProps => {
    const { key } = selectProps
    const anchorKeys = Object.keys(ANCHOR_LINK_MAP)
    const anchorKey = anchorKeys[key]
    const gaLabel = _.get(ANCHOR_GA_LABEL_MAP, anchorKey)

    if (gaLabel) {
      onGaClick(gaLabel)
    }
  }

  const onAnchorChange = link => {
    if (_.isEmpty(link)) {
      return
    }

    window.history.replaceState(undefined, undefined, link)
  }

  useEffect(() => {
    if (defaultSelected === hash) {
      return
    }

    setDefaultSelected(hash)
  }, [hash, defaultSelected])

  return (
    <div className={styles.sidebar}>
      <Anchor
        affix={false}
        // 選擇 item 後要移至目標距離畫面頂端多遠
        targetOffset={0}
        onChange={onAnchorChange}
      >
        <SideBar
          items={getSideBarItems(envConf)}
          onSelect={onSelect}
          defaultSelected={defaultSelected}
        />
      </Anchor>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const envConf = _.get(state, 'page.envConf', {})
  return {
    envConf
  }
}

export default connect(
  mapStateToProps
)(Sidebar)
